import {Component, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {BausteinHeaderConfig} from '../../model/baustein-header-config';
import {BausteinContentConfig} from '../../model/baustein-content-config';
import { Baustein } from 'src/app/model/structured-content-models';
import { TariffStatusChangedEventArgs } from 'src/app/model/tariff-status-changed-event-args';
import { ContextType } from 'src/app/service/price-box-communication.service';

@Component({
  selector: 'app-baustein',
  templateUrl: './baustein.component.html',
  styleUrls: ['./baustein.component.scss']
})
export class BausteinComponent implements OnInit {

  @Input() baustein: Baustein;
  @Input() isFirst: boolean;
  @Input() isDouble: boolean;
  @Input() isAlternativeColor: boolean;
  @Input() context: ContextType;

  public headerConfig: BausteinHeaderConfig = new BausteinHeaderConfig();
  public contentConfig: BausteinContentConfig = new BausteinContentConfig();
  @Output() tariffActiveStatusChanged = new EventEmitter<TariffStatusChangedEventArgs>();
  @Output() tariffStatusChanged = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.headerConfig.headlineWithInfo = this.baustein.headlineWithInfo;
    this.headerConfig.tariffOption = this.baustein.tariffOption;

    this.contentConfig.context = this.context;
    this.contentConfig.additionalText = this.baustein.additionalText;

    this.contentConfig.tariff = this.baustein.tariffOption;
    this.contentConfig.text = this.baustein.teaserText.content;

    if (this.baustein.tariffOption != null) {
      this.contentConfig.selectionFields = this.baustein.tariffOption.detailselectionfieldList;
    }
  }

  onTariffActiveStatusChanged(args: TariffStatusChangedEventArgs) {
    if (this.tariffActiveStatusChanged) {
      this.tariffActiveStatusChanged.emit(args);
    }
  }

  onTariffStatusChanged(tariffId: string) {
    if (this.tariffStatusChanged) {
      this.tariffStatusChanged.emit(tariffId);
    }
  }
}
